<script setup>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { defineProps } from 'vue'
import UnderlinedTitle from '@components/UnderlinedTitle'
import { getRouteDataForWorkItem } from '@helpers/router'

const router = useRouter()
const store = useStore()

const props = defineProps({
  oppositeWorkList: {
    type: Array,
    required: true
  }
})

const locale = store.getters['Global/locale']
const getOppositeHref = (oppositeWork) => {
  return router.resolve(getRouteDataForWorkItem(oppositeWork, locale)).path
}

</script>
<template>
  <div
    class="detail-opposite-work"
    data-cy="opposite-work"
  >
    <UnderlinedTitle
      tag="h2"
      tag-class="h5"
      :title="$t('oppositeWorkList.title')"
    />
    <div class="nfb-opposite-work__link">
      <a
        class="nfb-font__body--md--sans"
        v-for="oppositeWork in props.oppositeWorkList"
        :key="oppositeWork.id"
        :href="getOppositeHref(oppositeWork)"
      >
        {{ oppositeWork.title }}
      </a>
    </div>
  </div>
</template>
<style lang="sass">
@use '../../sass/utils'

.nfb-opposite-work__link
  margin: utils.$nfb-spacing__sm 0

  a
    display: block
</style>
